<template>
  <b-row class="User mb-2">
    <b-col cols="12" lg="10" offset-lg="1">
      <b-card>
        <b-card-title title-tag="h2" class="mb-5">
          Account Settings
        </b-card-title>

        <b-row>
          <b-col class="mb-3" cols="12" lg="3">
            <b-nav vertical class="w-100">
              <template v-for="(item, idx) in settingsNav">
                <b-nav-item
                  v-if="item.label && !item.hidden"
                  :key="`nav_${idx}`"
                  :active="item.active"
                  :to="item.link"
                  :disabled="item.disabled"
                >
                  {{ item.label || $startCase(item.name) }}
                </b-nav-item>
                <b-nav-item
                  v-else-if="item.html"
                  :key="`nav_${idx}`"
                  :active="item.active"
                  :to="item.link"
                  :disabled="item.disabled"
                  v-html="item.html"
                />
              </template>
            </b-nav>
          </b-col>

          <b-col cols="12" lg="9" class="vld-parent">
            <router-view></router-view>
          </b-col>
        </b-row>

      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'Account',
  mounted() {
    if (!this.initPassword) {
      this.setAlert({
        show: true,
        variant: 'warning',
        message: 'Please change your password to proceed.',
        icon: { name: 'key' },
      });
    }
  },
  computed: {
    activeTab() {
      const routeName = this.$route.name;
      return routeName;
    },
    settingsNav() {
      const setIfActive = (item) => {
        const linkName = this.$get(item, 'link.name', '');
        return Object.assign({}, item, { active: this.activeTab === linkName });
      };
      const navArray = [
        {
          label: 'Account',
          name: 'account',
          link: { name: 'user.account' },
          hidden: !this.initPassword,
        },
        {
          label: 'Password',
          name: 'password',
          link: { name: 'user.password' },
        },
      ];
      return navArray.map(setIfActive)
        .map(item => Object.assign({}, item, { disabled: item.disabled || this.$ie(item.link) }));
    },
    ...mapGetters([
      'isLoadingRequest',
      'isAdmin',
      'initPassword',
    ]),
  },
  methods: {
    ...mapActions([
      'startLoadingRequest',
      'stopLoadingRequest',
      'setAlert',
    ]),
  },
};
</script>
<style lang="scss" scoped>
@import '../styles/base/_variables';
.User {
  .nav-link {
    margin-bottom: 5px;
    border-radius: 0.25rem;

    &:hover {
      background-color: lighten($primary, 50);
    }

    &.active {
      background-color: $primary;
      color: #fff;
    }
  }
}
</style>
